class AppController {
  constructor(SecurityService) {
    'ngInject';

    this.SecurityService = SecurityService;
  }

  $onInit() {
    this.SecurityService.initialize();
  }
}

export default AppController;


// WEBPACK FOOTER //
// ./client/app/app.controller.js